exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".head_line{background-color: #e9ecef;}\n.cancel_attendee .row{border-bottom: 1px solid #e9ecef;}\n.cancel_attendee .row:hover{background-color: #e9ecef;}\n.cancel_attendee b, .cancel_attendee p{padding: 11px 10px; margin: 0px; display: inline-block;}\n.cancel_dialog{min-width: 750px;}\n.cancel_attendee input[type=checkbox]{margin: 15px;}\n.cancel_attendee .col-md-1, .cancel_attendee .col-md-2, .cancel_attendee .col-md-3{padding: 0px !important;}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/www/html/nissco_event_web/angular/src/app/admin/admin-full-cancel/admin-full-cancel.component.css
// module id = ../../../../../src/app/admin/admin-full-cancel/admin-full-cancel.component.css
// module chunks = 39